import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import './theme.css';
import BotStatus from './components/BotStatus';
import Configuration from './components/Configuration';
import BotsCnc from './components/BotsCnc';
import BotGroupWizard from './components/BotGroupWizard';
import ExperimentWizard from './components/ExperimentWizard';
import Login from './components/Login';
import { useAuth } from './contexts/AuthContext';


const Navigation: React.FC = () => {
  const location = useLocation();
  const { logout, username } = useAuth();
  
  const handleLogout = () => {
    logout();
  };
  
  return (
    <nav className="main-nav">
      <div className="nav-brand">
        <button onClick={() => window.location.href = '/'} className="nav-brand-logo-button">
        <img src="/resources/spring-logo.svg" alt="Spring" style={{ width: '250px', height: '48px', marginRight: '8px' }} />
        </button>
      </div>
      <div className="nav-links">
        <Link 
          to="/" 
          className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
        >
          Bot Status
        </Link>
        <Link 
          to="/bots-cnc" 
          className={`nav-link ${location.pathname === '/bots-cnc' ? 'active' : ''}`}
        >
          Command & Control
        </Link>
        <Link 
          to="/configuration" 
          className={`nav-link ${location.pathname === '/configuration' ? 'active' : ''}`}
        >
          Configuration
        </Link>
        <Link 
          to="/wizard" 
          className={`nav-link ${location.pathname === '/wizard' ? 'active' : ''}`}
        >
          Create Bot Group
        </Link>
        <Link 
          to="/experiments" 
          className={`nav-link ${location.pathname === '/experiments' ? 'active' : ''}`}
        >
          Create Experiment
        </Link>
        <div className="nav-user">
          <span className="nav-username">{username}</span>
          <button onClick={handleLogout} className="nav-logout-btn">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

const AppContent: React.FC = () => {
  return (
    <div className="App">
      <Navigation />
      <Routes>
        <Route path="/" element={<BotStatus />} />
        <Route path="/wizard" element={<BotGroupWizard />} />
        <Route path="/experiments" element={<ExperimentWizard />} />
        <Route path="/configuration" element={<Configuration />} />
        <Route path="/bots-cnc" element={<BotsCnc />} />
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  const { isAuthenticated, login } = useAuth();

  if (!isAuthenticated) {
    return <Login onLogin={login} />;
  }

  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App; 